import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useState } from "react";
import thumbs from "../../assets/images/thumbs.webp";
import MockTooltipComponent from "./MockTooltipComponent";
import riskIcon from "../../assets/images/red.svg";

const MockGlobalRiskReportModal = ({ onCallBack }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  return (
    <div>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={open}
        classes={{
          paper: classes.dialog,
        }}
      >
        <MockTooltipComponent
          placement="left-start"
          open={open}
          popper={classes.keepTrackTooltip}
          tooltipArrowStyle={classes.locationArrowStyle}
          title={
            <>
              <Typography className={classes.tooltipTitleStyle}>
                Keep track of risks
              </Typography>
              <p className={classes.tooltipTextStyle}>
                Kavida keeps track of all disruption risks near your suppliers.
                <span className={classes.newLine}>
                  so you can get a better view of both regional and global supply
                  chain issues.
                </span>
              </p>
              <div
                style={{
                  width: "64px",
                  padding: "8px",
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  fontWeight: 600,
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpen(false);
                  onCallBack();
                }}
              >
                <span>Continue</span>
              </div>
              <Typography className={classes.stepTextStyle}>
                (17/19)
              </Typography>
            </>
          }
          child={
            <div className={classes.modalRoot}>
              <Grid container spacing={2}>
                <Grid item xs={10}>
                  <div style={{ display: "flex" }}>
                    <img src={riskIcon} className={classes.riskIcon} />
                    <Typography className={classes.composeEmailStyle}>
                      IMD warns of heavy rainFall across Tamil Nadu for next 2 days, shares update on SW monsoon
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={1}>
                  <Icon
                    baseClassName="fas"
                    className="fa solid fa-xmark"
                    style={{
                      fontSize: "16px",
                      color: "#000000",
                      marginLeft: '16px',
                      opacity: 0.5,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "24px" }}>
                <Grid item xs={12}>
                  <Typography
                    className={classes.newsText}
                  >{`Kavida News | Environment`}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <p className={classes.reportAffectedText}>
                    3 <u>supplier(s)</u> in Tier 1 have been affected
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <p
                    className={classes.reportAffectedText}
                    style={{ marginTop: "10px" }}
                  >
                    Is this news relevant to your interests?
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <img
                    src={thumbs}
                    style={{
                      height: "48px"
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          }
        />
      </Dialog>
    </div>
  );
};

export default MockGlobalRiskReportModal;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "350px",
    height: "auto",
    padding: "24px 24px",
    overflow: "hidden",
  },
  composeEmailStyle: {
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: "700",
    lineHeight: "24px",
  },
  newsText: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    opacity: 0.2,
    marginTop: "-24px",
  },
  backDrop: {
    backdropFilter: "blur(8px)",
    backgroundColor: "rgba(255,255,255,0.01)",
  },
  dialog: {
    position: "absolute",
    left: "55%",
    top: "25%",
  },
  reportAffectedText: {
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "300",
    margin: '8px 0px',
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Inter",
    marginBottom: "8px",
  },
  keepTrackTooltip: {
    width: "375px",
    height: "160px",
    marginTop: "130px !important",
    marginRight: "-70px"
  },
  locationArrowStyle: {
    marginTop: "-120px !important",
    top: '200px !important',
    color: '#373D3F'
  },
  riskIcon: {
    paddingBottom: "96px",
    paddingRight: "10px",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  newLine: {
    display: "block",
    marginTop: "15px"
  }
}));
